import { Box, useTheme } from '@mui/material';

const PaymentMethodSelectorButton = ({ selected, children, onClick }) => {
  const theme = useTheme();
  return (
    <Box
      component="button"
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        padding: '1rem',
        backgroundColor: selected
          ? theme.palette.primary.main
          : theme.palette.grey[50],
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        width: '100%',
        flex: 1,
        maxWidth: '300px',
        '&:hover': {
          backgroundColor: selected
            ? theme.palette.primary.dark
            : theme.palette.grey[100],
        },
        outline: 'none',
        '&:focus': {
          boxShadow: `0 0 0 2px ${theme.palette.primary.main}25`,
        },
        '& .icon': {
          fontSize: '24px',
          color: selected
            ? theme.palette.primary.contrastText
            : theme.palette.text.primary,
        },
        '& .title': {
          color: selected
            ? theme.palette.primary.contrastText
            : theme.palette.text.primary,
          fontSize: '0.875rem',
          fontWeight: 500,
          textAlign: 'left',
          lineHeight: 1.2,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default PaymentMethodSelectorButton;
